/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSelectedImage, setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
import { getUnsplash, clearImageTab } from 'state/actions/embedsState/embedManagementState/image_status';
// component
import Unsplash from 'material/embeds/imageapi/imagepane/pane/images/unsplash/unsplash';



/* ========== ~~~~~~~~~~ UNSPLASH : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection, // background, questionImage, option_0, option_1, option_2, option_3
    provider: embedsState.embedManagementState.imageStatus.provider, 
    images: {
        data: embedsState.embedManagementState.imageStatus.images, 
        length: embedsState.embedManagementState.imageStatus.images.length
    },
    isDataReceived: embedsState.embedManagementState.imageStatus.isDataReceived,
    error: embedsState.embedManagementState.imageStatus.error
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL)),
    getUnsplash: (query, page) => dispatch(getUnsplash(query, page)),
    clearImageTab: () => dispatch(clearImageTab())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Unsplash);
